import { closeHistory, processImgDelete, processImgDoc, processImgTag } from 'assets/icons'
import moment from 'moment';
import { Checkbox, CheckboxChangeEvent } from 'primereact/checkbox';
import React, { useState } from 'react'
import { useSearchParams } from 'react-router-dom';

interface ImageHisotryById {
    _id: string,
    conversation_id: string,
    input_image_id: string,
    output_image_id: string[],
    user_name: string,
    image_extension: string,
    input_path: string;
    output_path: string[];
    system_prompt: string;
    notes: string;
    tag: string[];
    created_at: string;
    version: number;
    original_input_image_path?: string;
    title?: string;
}
interface ImageHistoryType {
    isImageHistory: boolean;
    handleImageHistory: () => void;
    data: any;
    historyByConversationId: (id: string, secondId: string) => Promise<void>
    historyImagesById: ImageHisotryById[];
    activeAccordion: string | null;
    getDataByImageId: (conversationId: string | null, imageId: string | null, isRefresh: boolean) => Promise<void>;
    handleOriginalImageClick: (conversationId: string | null, imageId: string | null, isRefresh: boolean) => Promise<void>
    setConfirm: React.Dispatch<React.SetStateAction<boolean>>;
    setDeleteId: React.Dispatch<React.SetStateAction<string>>;
    setDeleteC_Id: React.Dispatch<React.SetStateAction<string>>;
    uniqueTagList: string[];
    selectedCategories: string[];
    setSelectedCategories: React.Dispatch<React.SetStateAction<string[]>>;
    // uniqueTagsForFilter: (setValue: React.Dispatch<React.SetStateAction<string[]>>) => Promise<void>
    setActivateSuggestion: React.Dispatch<React.SetStateAction<boolean>>;
}

const ImageHistory = ({ isImageHistory, handleImageHistory, data, historyByConversationId, historyImagesById, activeAccordion, getDataByImageId, setConfirm, setDeleteId, uniqueTagList, selectedCategories, setSelectedCategories, handleOriginalImageClick, setDeleteC_Id, setActivateSuggestion }: ImageHistoryType) => {
    const apiUrl = process.env.RON_LENS_IMAGE || (window.location.origin === 'https://ron.rysun.in:3001' || window.location.origin === 'https://shoptalk.rysun.com') ? "https://ronimages.rysun.in/" : 'http://43.242.38.46/';
    const [searchParams] = useSearchParams();
    const conversationId: string | null = searchParams.get('conversation_id');
    const imageId: string | null = searchParams.get('input_image_id');
    const handleModalOpen = (e: any, id: string, c_id: string) => {
        e.stopPropagation();
        setConfirm(true);
        setDeleteId(id);
        setDeleteC_Id(c_id);
    }
    const [search, setSearch] = useState<boolean>(false);
    const [category, setCategory] = useState<string[]>(selectedCategories);
    const [checked, setChecked] = useState<boolean>(false);
    const onCategoryChange = (e: CheckboxChangeEvent) => {
        let _selectedCategories = [...category];

        if (e.checked)
            _selectedCategories.push(e.value);
        else
            _selectedCategories = _selectedCategories.filter(category => category !== e.value);

        setCategory(_selectedCategories);
        setChecked(_selectedCategories.length === uniqueTagList.length);
    };
    const handleSelectAll = (e: any) => {
        setChecked(e.checked);
        if (e.checked) {
            setCategory([...uniqueTagList])
        } else {
            setCategory([])
        }
    }
    const capitalizeFirstLetter = (string: string) => {
        if (!string) return '';
        return string.charAt(0).toUpperCase() + string.slice(1);
    };
    const handleHistoryNameTitle = (conversation: any) => {
        if (selectedCategories.length > 0) {
            if (conversation?.system_prompt?.length > 30) {
                return capitalizeFirstLetter(conversation?.system_prompt)
            }
        } else {
            if (conversation?.title?.length > 30) {
                return capitalizeFirstLetter(conversation?.title)
            }
        }
    }
    const handleHistoryName = (conversation: any) => {
        if (selectedCategories.length > 0) {
            if (conversation?.system_prompt?.length > 30) {
                return capitalizeFirstLetter(`${conversation?.system_prompt.slice(0, 30).trim()}...`)
            } else {
                return capitalizeFirstLetter(conversation?.system_prompt)
            }
        } else {
            if (conversation?.title?.length > 30) {
                return capitalizeFirstLetter(`${conversation?.title.slice(0, 30).trim()}...`)
            } else {
                return capitalizeFirstLetter(conversation?.title)
            }
        }
    }
    return (
        <div className={isImageHistory ? "image-history show" : "image-history"}>
            <div className='image-history-header'>
                {!search ?
                    <>
                        <span className='chat-history-title'>Image History</span>
                        <i className={`pi pi-filter${selectedCategories.length > 0 ? "-fill" : ""}`} title='Filter By Tags' style={{ cursor: uniqueTagList.length > 0 ? "pointer" : "default" }} onClick={() => {
                            if (uniqueTagList.length > 0) { setSearch(true); setCategory(selectedCategories) }; if (uniqueTagList.length !== selectedCategories.length) { setChecked(false) } else {
                                setChecked(true)
                            }
                        }}></i>
                    </> :
                    <>
                        <span className='chat-history-title'>Filter By Tags</span>
                        <i className="pi pi-times" onClick={() => { setSearch(false); setCategory([]) }}></i>
                    </>

                }


            </div>
            <div className='image-history-body'>
                {!search ?
                    <>
                        {Object.keys(data).map((date, indexDate) => {
                            return data[date].length > 0 &&
                                <span key={date}>
                                    <div className='date-seprator'>
                                        {date}
                                    </div>
                                    <div className='image-accordian'>
                                        <div className="accordion accordion-flush" id={`accordionFlushExample_${indexDate}`}>
                                            {data[date].map((conversation: any, index: number) => (
                                                <div className="accordion-item" key={index}>
                                                    <h6 className="accordion-header" onClick={() => historyByConversationId(conversation.conversation_id, `flush-collapse/${indexDate}/${conversation.conversation_id}`)}>
                                                        <button
                                                            className={`accordion-button ${activeAccordion === `flush-collapse/${indexDate}/${conversation.conversation_id}` ? '' : 'collapsed'}`}
                                                            type="button"
                                                            // data-bs-toggle="collapse"
                                                            // data-bs-target={`#flush-collapse/${indexDate}/${conversation.conversation_id}`}
                                                            aria-expanded={activeAccordion === `flush-collapse/${indexDate}/${conversation.conversation_id}`}
                                                            aria-controls={`flush-collapse/${indexDate}/${conversation.conversation_id}`}
                                                        >
                                                            <a title={handleHistoryNameTitle(conversation)}>{handleHistoryName(conversation)}</a>
                                                        </button>
                                                    </h6>
                                                    <div
                                                        id={`flush-collapse/${indexDate}/${conversation.conversation_id}`}
                                                        className={`accordion-collapse collapse ${activeAccordion === `flush-collapse/${indexDate}/${conversation.conversation_id}` ? 'show' : ''}`}
                                                    // data-bs-parent={`#accordionFlushExample_${indexDate}`}
                                                    >
                                                        <div className="accordion-body">
                                                            <ul className='image-accordian-list'>
                                                                {historyImagesById?.map((img: ImageHisotryById, indexName: number) => (
                                                                    <>
                                                                        {indexName === 0 && selectedCategories?.length === 0 &&
                                                                            <li onClick={() => handleOriginalImageClick(img?.conversation_id, img?.input_image_id, false)} style={{ background: imageId === "original" && conversationId === img.conversation_id ? "rgba(80, 90, 214, 0.12)" : "" }}>
                                                                                <figure>
                                                                                    <img src={img?.original_input_image_path?.replace("/var/www/html/", apiUrl)} alt='lens-img' />
                                                                                </figure>
                                                                                <div className='img-info'>
                                                                                    <div className='imd-data'>
                                                                                        <span>Original</span>
                                                                                        <p>{moment(img?.created_at)?.format('DD/MM/YYYY HH:mm:ss')}</p>
                                                                                    </div>
                                                                                    {/* <span className='process-dlt-img' onClick={(e) => handleModalOpen(e, img?.input_image_id)}>
                                                                                        <i><img src={processImgDelete} alt='delete-icon' /></i>
                                                                                    </span> */}
                                                                                </div>
                                                                            </li>}
                                                                        <li onClick={() => getDataByImageId(img?.conversation_id, img?.input_image_id, false)} style={{ background: imageId === img?.input_image_id ? "rgba(80, 90, 214, 0.12)" : "" }}>
                                                                            <figure>
                                                                                {/* <img src={indexName === 0 ? img?.input_path?.replace("/var/www/html/", apiUrl) : img?.output_path[0]?.replace("/var/www/html/", apiUrl)} alt='lens-img' /> */}
                                                                                <img src={img?.output_path[0]?.replace("/var/www/html/", apiUrl)} alt='lens-img' />
                                                                            </figure>
                                                                            <div className='img-info'>
                                                                                <div className='imd-data'>
                                                                                    <span>{`Version ${img.version > 0 && img.version < 10 ? `0${img.version}` : img.version}`}{img?.notes !== "" && <i><img src={processImgDoc} alt='edit-icon' /></i>}{img?.tag?.length > 0 && img?.tag[0] !== "" && <i><img src={processImgTag} alt='tag-icon' /></i>}</span>
                                                                                    <p>{moment(img?.created_at)?.format('DD/MM/YYYY HH:mm:ss')}</p>
                                                                                </div>
                                                                                {/* {indexName > 0 && */}
                                                                                <span className='process-dlt-img' onClick={(e) => handleModalOpen(e, img?.input_image_id, img?.conversation_id)}>
                                                                                    <i><img src={processImgDelete} alt='delete-icon' /></i>
                                                                                </span>
                                                                                {/* } */}
                                                                            </div>
                                                                        </li>
                                                                    </>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </span>
                        })}
                    </> :
                    <>
                        <div className='filter-seprator'>
                            <div className="flex align-items-center">
                                <Checkbox inputId="SelectAll" onChange={handleSelectAll} checked={checked}></Checkbox>
                                <label htmlFor="SelectAll" className='c-pointer'>
                                    Select All
                                </label>
                            </div>
                            {uniqueTagList?.map((cgy) => {
                                return (
                                    <div key={cgy} className="flex align-items-center mb-1">
                                        <Checkbox inputId={cgy} name="category" value={cgy} onChange={onCategoryChange} checked={category.some((item) => item === cgy)} />
                                        <label htmlFor={cgy} className="ml-2 c-pointer">
                                            {capitalizeFirstLetter(cgy)}
                                        </label>
                                    </div>
                                )
                            })}
                        </div>
                        <div className='filter-seprator-footer'>
                            <button className="outline-active-btn" onClick={() => { setSelectedCategories(category); setSearch(false) }}>Apply</button>
                            <button className="outline-icon-btn" style={{ pointerEvents: category.length === 0 ? "none" : "auto" }} disabled={category.length === 0} onClick={() => { setCategory([]); setChecked(false) }}>Reset</button>
                        </div>
                    </>

                }
                {/* <div className='date-seprator'>
                    Today
                </div>
                <div className='image-accordian'>
                    <Accordion activeIndex={0}>
                        <AccordionTab header="Image 1">
                            <ul className='image-accordian-list'>
                                <li>
                                    <figure>
                                        <img src="http://10.1.1.77//runs/detect/predict15/image0.jpg?timestamp=1716453404401" alt='lens-img' />
                                    </figure>
                                    <div className='img-info'>
                                        <div className='imd-data'>
                                            <span>Original<i><img src={processImgDoc} alt='edit-icon' /></i><i><img src={processImgTag} alt='tag-icon' /></i></span>
                                            <p>29/4/2024  10:00 AM</p>
                                        </div>
                                        <span className='process-dlt-img'>
                                            <i><img src={processImgDelete} alt='delete-icon' /></i>
                                        </span>
                                    </div>
                                </li>
                                <li>
                                    <figure>
                                        <img src="http://10.1.1.77//runs/detect/predict15/image0.jpg?timestamp=1716453404401" alt='lens-img' />
                                    </figure>
                                    <div className='img-info'>
                                        <div className='imd-data'>
                                            <span>Version 01<i><img src={processImgTag} alt='tag-icon' /></i></span>
                                            <p>29/4/2024  10:00 AM</p>
                                        </div>
                                        <span className='process-dlt-img'>
                                            <i><img src={processImgDelete} alt='delete-icon' /></i>
                                        </span>
                                    </div>
                                </li>
                                <li>
                                    <figure>
                                        <img src="http://10.1.1.77//runs/detect/predict15/image0.jpg?timestamp=1716453404401" alt='lens-img' />
                                    </figure>
                                    <div className='img-info'>
                                        <div className='imd-data'>
                                            <span>Version 02<i><img src={processImgDoc} alt='edit-icon' /></i></span>
                                            <p>29/4/2024  10:00 AM</p>
                                        </div>
                                        <span className='process-dlt-img'>
                                            <i><img src={processImgDelete} alt='delete-icon' /></i>
                                        </span>
                                    </div>
                                </li>
                                <li>
                                    <figure>
                                        <img src="http://10.1.1.77//runs/detect/predict15/image0.jpg?timestamp=1716453404401" alt='lens-img' />
                                    </figure>
                                    <div className='img-info'>
                                        <div className='imd-data'>
                                            <span>Version 03<i><img src={processImgDoc} alt='edit-icon' /></i><i><img src={processImgTag} alt='tag-icon' /></i></span>
                                            <p>29/4/2024  10:00 AM</p>
                                        </div>
                                        <span className='process-dlt-img'>
                                            <i><img src={processImgDelete} alt='delete-icon' /></i>
                                        </span>
                                    </div>
                                </li>
                            </ul>
                        </AccordionTab>
                        <AccordionTab header="Image 2">
                            <ul className='image-accordian-list'>
                                <li>
                                    <figure>
                                        <img src="http://10.1.1.77//runs/detect/predict15/image0.jpg?timestamp=1716453404401" alt='lens-img' />
                                    </figure>
                                    <div className='img-info'>
                                        <div className='imd-data'>
                                            <span>Original<i><img src={processImgDoc} alt='edit-icon' /></i><i><img src={processImgTag} alt='tag-icon' /></i></span>
                                            <p>29/4/2024  10:00 AM</p>
                                        </div>
                                        <span className='process-dlt-img'>
                                            <i><img src={processImgDelete} alt='delete-icon' /></i>
                                        </span>
                                    </div>
                                </li>
                                <li>
                                    <figure>
                                        <img src="http://10.1.1.77//runs/detect/predict15/image0.jpg?timestamp=1716453404401" alt='lens-img' />
                                    </figure>
                                    <div className='img-info'>
                                        <div className='imd-data'>
                                            <span>Version 01<i><img src={processImgTag} alt='tag-icon' /></i></span>
                                            <p>29/4/2024  10:00 AM</p>
                                        </div>
                                        <span className='process-dlt-img'>
                                            <i><img src={processImgDelete} alt='delete-icon' /></i>
                                        </span>
                                    </div>
                                </li>
                                <li>
                                    <figure>
                                        <img src="http://10.1.1.77//runs/detect/predict15/image0.jpg?timestamp=1716453404401" alt='lens-img' />
                                    </figure>
                                    <div className='img-info'>
                                        <div className='imd-data'>
                                            <span>Version 02<i><img src={processImgDoc} alt='edit-icon' /></i></span>
                                            <p>29/4/2024  10:00 AM</p>
                                        </div>
                                        <span className='process-dlt-img'>
                                            <i><img src={processImgDelete} alt='delete-icon' /></i>
                                        </span>
                                    </div>
                                </li>
                                <li>
                                    <figure>
                                        <img src="http://10.1.1.77//runs/detect/predict15/image0.jpg?timestamp=1716453404401" alt='lens-img' />
                                    </figure>
                                    <div className='img-info'>
                                        <div className='imd-data'>
                                            <span>Version 03<i><img src={processImgDoc} alt='edit-icon' /></i><i><img src={processImgTag} alt='tag-icon' /></i></span>
                                            <p>29/4/2024  10:00 AM</p>
                                        </div>
                                        <span className='process-dlt-img'>
                                            <i><img src={processImgDelete} alt='delete-icon' /></i>
                                        </span>
                                    </div>
                                </li>
                            </ul>
                        </AccordionTab>
                    </Accordion>
                </div>
                <div className='date-seprator'>
                    Yesterday
                </div>
                <div className='image-accordian'>
                    <Accordion activeIndex={0}>
                        <AccordionTab header="Image 1">
                            <ul className='image-accordian-list'>
                                <li>
                                    <figure>
                                        <img src="http://10.1.1.77//runs/detect/predict15/image0.jpg?timestamp=1716453404401" alt='lens-img' />
                                    </figure>
                                    <div className='img-info'>
                                        <div className='imd-data'>
                                            <span>Original<i><img src={processImgDoc} alt='edit-icon' /></i><i><img src={processImgTag} alt='tag-icon' /></i></span>
                                            <p>29/4/2024  10:00 AM</p>
                                        </div>
                                        <span className='process-dlt-img'>
                                            <i><img src={processImgDelete} alt='delete-icon' /></i>
                                        </span>
                                    </div>
                                </li>
                                <li>
                                    <figure>
                                        <img src="http://10.1.1.77//runs/detect/predict15/image0.jpg?timestamp=1716453404401" alt='lens-img' />
                                    </figure>
                                    <div className='img-info'>
                                        <div className='imd-data'>
                                            <span>Version 01<i><img src={processImgTag} alt='tag-icon' /></i></span>
                                            <p>29/4/2024  10:00 AM</p>
                                        </div>
                                        <span className='process-dlt-img'>
                                            <i><img src={processImgDelete} alt='delete-icon' /></i>
                                        </span>
                                    </div>
                                </li>
                                <li>
                                    <figure>
                                        <img src="http://10.1.1.77//runs/detect/predict15/image0.jpg?timestamp=1716453404401" alt='lens-img' />
                                    </figure>
                                    <div className='img-info'>
                                        <div className='imd-data'>
                                            <span>Version 02<i><img src={processImgDoc} alt='edit-icon' /></i></span>
                                            <p>29/4/2024  10:00 AM</p>
                                        </div>
                                        <span className='process-dlt-img'>
                                            <i><img src={processImgDelete} alt='delete-icon' /></i>
                                        </span>
                                    </div>
                                </li>
                                <li>
                                    <figure>
                                        <img src="http://10.1.1.77//runs/detect/predict15/image0.jpg?timestamp=1716453404401" alt='lens-img' />
                                    </figure>
                                    <div className='img-info'>
                                        <div className='imd-data'>
                                            <span>Version 03<i><img src={processImgDoc} alt='edit-icon' /></i><i><img src={processImgTag} alt='tag-icon' /></i></span>
                                            <p>29/4/2024  10:00 AM</p>
                                        </div>
                                        <span className='process-dlt-img'>
                                            <i><img src={processImgDelete} alt='delete-icon' /></i>
                                        </span>
                                    </div>
                                </li>
                            </ul>
                        </AccordionTab>
                        <AccordionTab header="Image 2">
                            <ul className='image-accordian-list'>
                                <li>
                                    <figure>
                                        <img src="http://10.1.1.77//runs/detect/predict15/image0.jpg?timestamp=1716453404401" alt='lens-img' />
                                    </figure>
                                    <div className='img-info'>
                                        <div className='imd-data'>
                                            <span>Original<i><img src={processImgDoc} alt='edit-icon' /></i><i><img src={processImgTag} alt='tag-icon' /></i></span>
                                            <p>29/4/2024  10:00 AM</p>
                                        </div>
                                        <span className='process-dlt-img'>
                                            <i><img src={processImgDelete} alt='delete-icon' /></i>
                                        </span>
                                    </div>
                                </li>
                                <li>
                                    <figure>
                                        <img src="http://10.1.1.77//runs/detect/predict15/image0.jpg?timestamp=1716453404401" alt='lens-img' />
                                    </figure>
                                    <div className='img-info'>
                                        <div className='imd-data'>
                                            <span>Version 01<i><img src={processImgTag} alt='tag-icon' /></i></span>
                                            <p>29/4/2024  10:00 AM</p>
                                        </div>
                                        <span className='process-dlt-img'>
                                            <i><img src={processImgDelete} alt='delete-icon' /></i>
                                        </span>
                                    </div>
                                </li>
                                <li>
                                    <figure>
                                        <img src="http://10.1.1.77//runs/detect/predict15/image0.jpg?timestamp=1716453404401" alt='lens-img' />
                                    </figure>
                                    <div className='img-info'>
                                        <div className='imd-data'>
                                            <span>Version 02<i><img src={processImgDoc} alt='edit-icon' /></i></span>
                                            <p>29/4/2024  10:00 AM</p>
                                        </div>
                                        <span className='process-dlt-img'>
                                            <i><img src={processImgDelete} alt='delete-icon' /></i>
                                        </span>
                                    </div>
                                </li>
                                <li>
                                    <figure>
                                        <img src="http://10.1.1.77//runs/detect/predict15/image0.jpg?timestamp=1716453404401" alt='lens-img' />
                                    </figure>
                                    <div className='img-info'>
                                        <div className='imd-data'>
                                            <span>Version 03<i><img src={processImgDoc} alt='edit-icon' /></i><i><img src={processImgTag} alt='tag-icon' /></i></span>
                                            <p>29/4/2024  10:00 AM</p>
                                        </div>
                                        <span className='process-dlt-img'>
                                            <i><img src={processImgDelete} alt='delete-icon' /></i>
                                        </span>
                                    </div>
                                </li>
                            </ul>
                        </AccordionTab>
                    </Accordion>
                </div> */}
            </div>
            {/* <Dialog header="Tag Filter" footer={footerContent} visible={search} style={{ width: '50vw' }} onHide={() => { if (!search) return; setSearch(false); }}>
                <div className="flex flex-wrap justify-content-center gap-3">
                    {uniqueTagList?.map((category) => {
                        return (
                            <div key={category} className="flex align-items-center">
                                <Checkbox inputId={category} name="category" value={category} onChange={onCategoryChange} checked={selectedCategories.some((item) => item === category)} />
                                <label htmlFor={category} className="ml-2">
                                    {category}
                                </label>
                            </div>
                        )
                    })}
                    <div className="flex align-items-center">
                        <Checkbox inputId="ingredient1" name="pizza" value="Cheese" onChange={onIngredientsChange} checked={ingredients.includes('Cheese')} />
                        <label htmlFor="ingredient1" className="ml-2">Cheese</label>
                    </div>
                    <div className="flex align-items-center">
                        <Checkbox inputId="ingredient2" name="pizza" value="Mushroom" onChange={onIngredientsChange} checked={ingredients.includes('Mushroom')} />
                        <label htmlFor="ingredient2" className="ml-2">Mushroom</label>
                    </div>
                    <div className="flex align-items-center">
                        <Checkbox inputId="ingredient3" name="pizza" value="Pepper" onChange={onIngredientsChange} checked={ingredients.includes('Pepper')} />
                        <label htmlFor="ingredient3" className="ml-2">Pepper</label>
                    </div>
                    <div className="flex align-items-center">
                        <Checkbox inputId="ingredient4" name="pizza" value="Onion" onChange={onIngredientsChange} checked={ingredients.includes('Onion')} />
                        <label htmlFor="ingredient4" className="ml-2">Onion</label>
                    </div>
                </div>
            </Dialog> */}
            {isImageHistory &&
                <i className='close-history' onClick={handleImageHistory}><img src={closeHistory} alt='close History' /></i>
            }
        </div>
    )
}

export default ImageHistory